import * as React from 'react';

import styles from './app-error-handler.module.css';

const DEFAULT_MESSAGE = 'Nutshell has experienced a temporary error.';

type Props = {
    children: any;
};

type State = {
    hasError: boolean;
    isRedirecting: boolean;
};

const LIST_PAGES = ['/people', '/companies', '/leads'];

export class AppErrorHandler extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            hasError: false,
            isRedirecting: false,
        };
    }

    componentDidCatch(error: Error) {
        if (
            LIST_PAGES.includes(window.location.pathname) &&
            !NutClientConfig.isDevelopmentOrPublisher
        ) {
            // Redirect back to default entity list page, better than being broken.
            setTimeout(() => {
                location.replace(
                    `${location.protocol}//${location.hostname}${location.pathname}?restoreDefaults`
                );
            }, 3000);
            this.setState({isRedirecting: true});
        }

        this.setState({hasError: true});
        // @ts-expect-error
        if (typeof window.trackJs !== 'undefined') {
            // TODO: remove this first track after a while.  Trying to isolate react 16 issues
            // @ts-expect-error
            window.trackJs.track('React16ErrorBoundary');
            // @ts-expect-error
            window.trackJs.track(error);
        }
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className={styles['app-error']}>
                    <img src='/include/images/layout/error-graphic.png' />
                    <h1 className={styles.message}>{DEFAULT_MESSAGE}</h1>
                    {this.state.isRedirecting ? (
                        <h2 className={styles.secondary}>
                            We’re loading the default list page for you…
                        </h2>
                    ) : (
                        <h2 className={styles.secondary}>
                            You can try refreshing the page, or{' '}
                            <a href='https://support.nutshell.com/'>contact our team</a>
                        </h2>
                    )}
                </div>
            );
        }

        return this.props.children;
    }
}
